import React, { useContext, useEffect } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { AppContext } from '../../../contexts/AppContext';
import ActiveControl from '../../../components/ActiveControl';
import useItemCategoryService from '../../../app/services/hooks/useItemCategoryService';

interface Props {
    categoryId: number;
    checkValue: boolean;
    callbackSuccess: () => void;
}

const ItemCategorySwitchChange = ({ categoryId, checkValue, callbackSuccess }: Props) => {
    const { hideLoading } = useContext(AppContext);
    const [checked, setChecked] = React.useState<boolean>(checkValue);
    const { activeCategory } = useItemCategoryService();

    useEffect(() => {
        setChecked(checkValue);
    }, [checkValue]);

    const active = (value: boolean) => {
        setChecked(value);
        activeCategory(categoryId, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                callbackSuccess();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setChecked(!value);
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            }
        });
    };

    return <ActiveControl status={checked} id={categoryId} callback={active} />;
};

export default ItemCategorySwitchChange;
